import { CodeDesignation } from './codeDesignation.model';

export class IdCodeDesignation extends CodeDesignation {
	id: number;

	constructor(id?: number, code?: string, designation?: string) {
		super(code, designation);
		this.id = id;
	}
}
